import { jsx as e } from "react/jsx-runtime";
import i from "clsx";
import { Heading as m } from "../../Heading/Heading.js";
import { cardSubtitleDefaultAs as s } from "./CardSubtitle.types.js";
const f = ({
  as: t = s,
  className: r,
  ...o
}) => /* @__PURE__ */ e(
  m,
  {
    as: t,
    className: i("text-color-tertiary", r),
    size: "xxs",
    ...o
  }
);
export {
  f as CardSubtitle
};
